import { Monitor } from "lucide-react";

/**
 * Composant d'avertissement pour les utilisateurs mobiles
 * Affiche un message demandant d'utiliser un ordinateur pour accéder à l'application
 */
export function MobileWarning() {
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-background p-6">
      <div className="max-w-md text-center space-y-6">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <img
            src="/lovable-uploads/c941c7a1-d271-4c8b-91a4-2611677da8a6.png"
            alt="Getproof"
            className="h-10"
          />
        </div>

        {/* Icône */}
        <div className="flex justify-center">
          <div className="w-20 h-20 rounded-full bg-primary/10 flex items-center justify-center">
            <Monitor className="w-10 h-10 text-primary" />
          </div>
        </div>

        {/* Message */}
        <div className="space-y-3">
          <p className="text-muted-foreground leading-relaxed">
            GetProof fonctionne mieux sur grand écran. Connectez-vous depuis votre ordinateur pour profiter de toutes les fonctionnalités.
          </p>
        </div>

        {/* Info supplémentaire */}
        <div className="pt-4 text-sm text-muted-foreground/70">
          La version mobile arrive bientôt ! 🚀
        </div>
      </div>
    </div>
  );
}
